import React from "react";
import { Col, Row } from "react-bootstrap";

const OtherFinancialInfo = ({ data }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">
                Are you currently party to law suit:
              </strong>
              {data?.are_you_currently_a_party_to_law_suit || "--"}
            </div>
          </Col>
          {data?.are_you_currently_a_party_to_law_suit == "Yes" && (
            <>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Plaintiff/Defendent:</strong>
                  {data?.law_suit_yes?.plaintiff_defendent || "--"}
                </div>
              </Col>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Location of Filing:</strong>
                  {data?.law_suit_yes?.location_of_filing || "--"}
                </div>
              </Col>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Case No:</strong>
                  {data?.law_suit_yes?.case_no || "--"}
                </div>
              </Col>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Subject of Suit:</strong>
                  {data?.law_suit_yes?.subject_of_suit || "--"}
                </div>
              </Col>
            </>
          )}

          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">
                Have you filed for bankcrupty protection:
              </strong>
              {data?.have_you_ever_filed_for_bankcrupty_protection || "--"}
            </div>
          </Col>
          {data?.have_you_ever_filed_for_bankcrupty_protection == "Yes" && (
            <>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Date of Filing:</strong>
                  {data?.bankcrupty_protection_yes?.date_of_filing || "--"}
                </div>
              </Col>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Date of Discharge:</strong>
                  {data?.bankcrupty_protection_yes?.date_of_discharge || "--"}
                </div>
              </Col>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Petition No:</strong>
                  {data?.bankcrupty_protection_yes?.petition_no || "--"}
                </div>
              </Col>
              <Col md={4} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Location:</strong>
                  {data?.bankcrupty_protection_yes?.location || "--"}
                </div>
              </Col>
            </>
          )}
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Increase/Decrease in Income:</strong>
              {data?.increase_decrease_in_income || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">
                Beneficiary to any trust, estate or life insurance:
              </strong>
              {data?.beneficiary_to_any_trust_estate_life_insurance || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default OtherFinancialInfo;
